import { Card, CardActionArea, CardContent, Grid, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { WrapperTable } from '../components'
import TableChartIcon from '@mui/icons-material/TableChart'
import { ROUTES } from '../../../router'

const reportes = [
    {
        title: 'Detalle Sistema - Unidad - Sector - Grupo',
        description: 'Reporte cruzado de sistemas, unidades de negocio, sectores comerciales y grupos',
        path: ROUTES.REPORTE_DETALLE_SISTEMA_GRUPO,
        icon: TableChartIcon,
        color: '#4f46e5'
    }
]

function ReportesPage() {
    const navigate = useNavigate()

    return (
        <WrapperTable>
            <Grid container spacing={3}>
                {reportes.map((reporte, index) => (
                    <Grid key={index} item xs={12} sm={6} md={4}>
                        <Card>
                            <CardActionArea onClick={() => navigate(`/admin/${reporte.path}`)}>
                                <CardContent>
                                    <Stack direction='row' spacing={2} alignItems='center'>
                                        <reporte.icon sx={{ color: reporte.color, fontSize: 40 }} />
                                        <Stack>
                                            <Typography variant='subtitle1' fontWeight={600}>
                                                {reporte.title}
                                            </Typography>
                                            <Typography variant='body2' color='text.secondary'>
                                                {reporte.description}
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </WrapperTable>
    )
}

export default ReportesPage
